import {Component, Input, OnInit} from "@angular/core";
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionType,
} from "../../../../../../user/user-subscription";
import {User} from "../../../../../../user/user";
import {ChosenPlan} from "../../../../payment-info/models/plan.model";
import {combineLatest, Subject, Subscription} from "rxjs";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {DbResponse} from "../../../../../interceptors/db-response";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {GoogleAnalyticsService} from "../../../../../services/google-analytics/google-analytics.service";
import {CookieService} from "ngx-cookie";
import {AuthService} from "../../../../../../auth/auth.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../../store";
import planFeatures from "./one-week-free-demo__plan/plans-features.json";
import featuresSteps from "./features-steps.json";
import {Website} from "../../../../../../websites/website/website";
import {Utils} from "../../../../../../shared/utils/utils";
import {animate, query, stagger, style, transition, trigger} from "@angular/animations";
import {
  AccountUpgradedDialogComponent
} from "../../../../../../shared/components/dialogs/account-upgraded-dialog/account-upgraded-dialog.component";
import {UserService} from "../../../../../../user/user.service";
import {DialogService} from "../../../../../../../ng2-bootstrap-modal/dialog.service";
import {GlobalEvent} from "../../../../../../shared/services/global-event-dispatcher/global-event";
import {UserManagementService} from "../../../../../../user-managment/user-management.service";
import {
  GlobalEventDispatcherService
} from "../../../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {Router} from "@angular/router";
import reviewers from "./reviewers.json";
import {Config} from "../../../../../../config/config";

@Component({
    selector: "db-one-week-free-demo-upgrade",
    templateUrl: "./one-week-free-demo-upgrade.component.html",
    styleUrls: ["./one-week-free-demo-upgrade.component.scss"],
    animations: [
        trigger("listAnimation", [
            transition("void => active", [
                query(".timeline-step", [
                    style({ transform: "translateY(-50px)", opacity: 0 }),
                    stagger(700, [
                        animate("1000ms ease-out", style({ transform: "translateY(0)", opacity: 1 })),
                    ]),
                ], { optional: true }),
            ]),
        ]),
    ],
    standalone: false
})
export class OneWeekFreeDemoUpgradeComponent implements OnInit {
  @Input() step = 1;
  @Input() showFirstTime = false;
  @Input() currentSubscription: UserSubscription;
  @Input() user: User;
  @Input() couponCode?: string;
  @Input() domainName?: string;
  @Input() customDomainFlow?: boolean;
  @Input() chosenPlan?: ChosenPlan;
  @Input() showAsEcommerce?: boolean;
  @Input() mode?: string;
  @Input() modeDesc?: string;
  @Input() isInvited: boolean = false;

  hasCouponForCampaign = false;
  periodSwitch: number = 12;
  loading: boolean;
  UserSubscriptionCategory = UserSubscriptionCategory;
  userHostingSubscriptions: UserSubscription[];
  subscriptionsTabs: object;
  activeTab: any = "business";
  UserSubscriptionType = UserSubscriptionType;
  planFeatures: any;
  isTier1Country?: boolean;
  applyCouponForPlatform?: boolean;
  couponPercent: number = 0;
  couponDays: number = 0;
  hasFreeDays: boolean = false;
  userSubscription: UserSubscription;
  demoUser: boolean;
  expirationDate: string;
  isMobile: boolean;
  isEcommerceWebsite = false;
  englishCountries = false;
  showBackButton = true;
  userLocalStorage: any;
  selectedPlanId: number = null;
  steps = featuresSteps;
  showAgencyTab = false;
  animateRightSide = false;
  animatePlans = false;
  animateSinglePlan = false;
  animateLeft = false;
  static = false;
  currentView: "business" | "agency" | "checkout" | "ecommerce" = "business";
  navigatingBack = false;
  reviewers = reviewers;
  singlePlanMode: boolean = false;
  campaignInfo: any;

  private _subscriptions: Subscription[];
  private readonly _destroyStream$ = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _cookieService: CookieService,
    private _authService: AuthService,
    private readonly _router: Router,
    private readonly _dialogService: DialogService,
    private readonly _userService: UserService,
    private readonly _userManagementService: UserManagementService,
    private readonly _globalEventDispatcher: GlobalEventDispatcherService,
    public readonly activeModal: DbActiveModal,
    private readonly _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    if (localStorage.getItem("dbCouponFromEmail")) {
      this.hasCouponForCampaign =
        localStorage
          .getItem("dbCouponFromEmail")
          .indexOf(Config.popupCouponPrefixForAutoApply) > -1 && !this.mode;
    }
    const getExperimentalCookie = this._cookieService.get("db-experiment");
    const cookieData =
      getExperimentalCookie && JSON.parse(getExperimentalCookie);
    this.singlePlanMode = cookieData &&
      cookieData.freeTrialPlanSelection &&
      cookieData.freeTrialPlanSelection === "singlePlan" && !this.mode;

    this.campaignInfo = this._userService.getCampaignInfo();

    this._getUserType();
    this.activeTab =
      this.showAsEcommerce || this.isEcommerceWebsite
        ? "ecommerce"
        : "business";
    if (this.showFirstTime && !this.singlePlanMode) {
      this.activeModal.hideCloseBtn(true);
      setTimeout(() => {
        this.showFirstTime = false;
        setTimeout(() => {
          this.activeModal.resize(
            this.singlePlanMode
              ? 769
              : this.activeTab === "ecommerce"
                ? 912
                : 766,
            1240
          );
          this.activeModal.hideCloseBtn(false);
          this.animateRightSide = true;
          setTimeout(() => {
            this.animatePlans = true;
          }, 500);
        }, 500);
      }, 4500);
      localStorage.setItem("dbShowFirstTime", "1");
    } else if (this.showFirstTime && this.singlePlanMode) {
      this.activeModal.hideCloseBtn(true);
      setTimeout(() => {
        this.activeModal.resize(769, 1240);
        this.animateSinglePlan = true;
        this.activeModal.hideCloseBtn(false);
        this.showFirstTime = false;
      }, 5000);
      localStorage.setItem("dbShowFirstTime", "1");
    } else {
      !this.mode &&
      this.activeModal.resize(
        this.singlePlanMode
          ? 769
          : this.activeTab === "ecommerce"
            ? 912
            : 766,
        1240
      );
      this.static = true;
      this.animatePlans = true;
      this.navigatingBack = true;
      this.animateSinglePlan = true;
    }

    this.isMobile = window.innerWidth <= 991;
    this.planFeatures = planFeatures;

    this.isTier1Country = getExperimentalCookie
      ? JSON.parse(getExperimentalCookie) &&
      JSON.parse(getExperimentalCookie).t1PExp &&
      JSON.parse(getExperimentalCookie).t1PExp === "b"
      : false;
    this.getAvailableSubscriptions().then(() => {
      if (this.singlePlanMode) {
        this._handleSinglePlanMode();
      } else if (
        this.subscriptionsTabs &&
        this.subscriptionsTabs[this.activeTab]
      ) {
        const mostPopularPlan = this.subscriptionsTabs[this.activeTab].find(
          (subscription) =>
            this.planFeatures[this.activeTab][
              subscription?.category?.toLowerCase()
              ]?.mostPopular
        );
        if (mostPopularPlan) {
          this.selectedPlanId = mostPopularPlan.id;
          this.handlePlanChange({
            id: mostPopularPlan.id,
            title: mostPopularPlan.plan.title,
            price: mostPopularPlan.plan.planPrice,
            tabCategory: mostPopularPlan?.plan?.shortFeatures?.tabCategory,
            type: this.periodSwitch === 12 ? "year" : "month",
            planPrice: mostPopularPlan.plan.price,
            coupon: mostPopularPlan.couponCode,
            periodNumber: mostPopularPlan.plan.periodNumber,
          });
        }
      }
    });
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  getStepClass(index: number, isCheckoutView): string {
    if (isCheckoutView) {
      return index === 0 ? "completed" : "pending";
    }
    return this.steps[index].completed ? "completed" : "pending";
  }

  public handlePlanChange(plan: ChosenPlan): void {
    this.selectedPlanId = plan.id;
    this.chosenPlan = plan;
    this.couponCode = plan.coupon;
    const date = new Date();
    if (!this.mode) {
      date.setDate(date.getDate() + 7);
      this.expirationDate = date.toDateString();
    } else {
      this._setNextBillingDate(date, plan.type === "month" ? 30 : 365);
    }
  }

  public proceedToCheckout(chosenPlan): void {
    if (!chosenPlan) {
      return;
    }
    this.chosenPlan = chosenPlan;
    const date = new Date();
    if (
      !this.mode &&
      this.chosenPlan.category !== UserSubscriptionCategory.DedicatedVM
    ) {
      date.setDate(date.getDate() + 7);
      this.expirationDate = date.toDateString();
    } else {
      this._setNextBillingDate(
        date,
        this.chosenPlan.type === "month" ? 30 : 365
      );
    }
    const analyticsData = {
      eventCategory: "Free Upgrade Offer",
      eventAction:
        "Checkout Page visit " +
        (!!this.mode ? "(Purchase pop-up)" : " 1wf pop-up"),
      eventLabel: this.chosenPlan.title + " " + this.chosenPlan.type + "ly",
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    this.currentView = "checkout";
    this.animateLeft = true;
    this.animateRightSide = false;
    this.activeModal.resize(
      600,
      !!this.mode ||
      chosenPlan?.category === UserSubscriptionCategory.DedicatedVM
        ? 480
        : 1000
    );
    this.navigatingBack = false;
  }

  changePeriod(): void {
    this.periodSwitch = this.periodSwitch === 12 ? 1 : 12;
    this.getAvailableSubscriptions();
    if (this.singlePlanMode && (this.currentView === 'ecommerce' || this.currentView === 'business')) {
      const analyticsData = {
        eventCategory: "Free Upgrade Offer",
        eventAction:
          "Checkout Page visit " +
          (!!this.mode ? "(Purchase pop-up)" : " Single plan"),
        eventLabel: this.chosenPlan.title + " " + (this.periodSwitch === 12 ? "yearly" : "monthly"),
      };
      this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    }
  }

  public resizeToNormal(isAgency?): void {
    this.animateRightSide = false;
    this.animateLeft = false;
    this.activeModal.resize(!!this.mode ? this.activeTab === 'ecommerce' ? 1024 : 878 : this.singlePlanMode ? 767 : this.activeTab === 'ecommerce' ? 912 : 766, !!this.mode && this.activeTab === 'ecommerce' && !isAgency ? 960 : 1240);
    this.navigatingBack = true;
    this._handleSinglePlanMode();
  }

  seeAgencyTab() {
    this.currentView = "agency";
    this.static = true;
    this.activeModal.resize(null, 1240);
    this._sendEvent('Free Upgrade Offer', "Change Subscription", "Agency Tab click");
  }

  showBusiness(): void {
    this.currentView = "business";
  }

  public closeModal(isUpgraded: boolean = false): void {
    if (isUpgraded) {
      localStorage.removeItem("dbCouponFromEmail");
      if (this.domainName) {
        this._generateDomainInfo(this.domainName);
      }
      this._showSuccessfullyUpgradedDialog();
    }
    this.activeModal.close();
  }

  selectPlan(subscription: UserSubscription): void {
    this.chosenPlan = {
      id: subscription.id,
      title: subscription.plan.title,
      price: subscription.plan.planPrice,
      tabCategory: subscription?.plan?.shortFeatures?.tabCategory,
      type: this.periodSwitch === 12 ? "year" : "month",
      coupon: subscription.couponCode,
      periodNumber: subscription.plan.periodNumber,
    };
    this.selectedPlanId = subscription.id;
    this.handlePlanChange(this.chosenPlan);
    this._sendEvent(this.chosenPlan);
  }

  onAnimationDone(event: any) {
    if (event.phaseName === "done" && this.showFirstTime) {
      this.showFirstTime = false;
    }
  }

  public addOwnWorkspace(event?) {
    if (!this.isInvited) {
      return;
    }

    if (!localStorage.getItem('dbPreviousWorkspaceId') || !localStorage.getItem('dbPreviousWorkspaceRoleId')) {
      localStorage.setItem('dbPreviousWorkspaceId', localStorage.getItem('dbCurrentWorkspaceId'));
      localStorage.setItem('dbPreviousWorkspaceRoleId', localStorage.getItem('dbCurrentWorkspaceRoleId'));
    }
    const switchToWorkspace = {
      ownerWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
      currentWorkspaceId: localStorage.getItem('dbOwnWorkspaceId'),
      currentWorkspaceRoleId: 1
    };
    this._store.dispatch(new fromStore.SwitchWorkspace({switching: true, workspaceName: '', redirect: false}));
    this._userManagementService.switchWorkspace(switchToWorkspace.currentWorkspaceId)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(response => {
        if (response.success) {
          this._globalEventDispatcher.dispatchEvent(GlobalEvent.workspaceSwitch);
          this._router.navigate(['/upgrade-plan']);
          this._store.dispatch(new fromStore.SwitchWorkspace({switching: true, workspaceName: '', redirect: false}));
        }
      });
  }

  private _setNextBillingDate(date: Date, freePeriodDays: number): void {
    let _date: Date;

    _date = new Date(date.getTime()); // Clone the date if it's already a Date object

    if (freePeriodDays === 30) {
      _date.setUTCMonth(_date.getUTCMonth() + 1);
    } else {
      _date.setUTCFullYear(_date.getUTCFullYear() + 1);
    }

    this.expirationDate = _date.toUTCString();
  }

  private async getAvailableSubscriptions(): Promise<void> {
    const tabs = {
      business: [],
      ecommerce: [],
      agency: [],
    };

    const categories = this.singlePlanMode
      ? [UserSubscriptionCategory.PERSONAL]
      : [
        UserSubscriptionCategory.PERSONAL,
        UserSubscriptionCategory.PREMIUM,
        UserSubscriptionCategory.ENTERPRISE,
      ];

    try {
      await new Promise<void>((resolve) => {
        this._store
          .select(fromStore.getUserLoaded)
          .pipe(first())
          .subscribe(() => resolve());
      });

      const availableSubscriptions = await this._store
        .select(fromStore.getUserAvailableHostingSubscriptions("platform"))
        .pipe(first((res) => !!res.length))
        .toPromise();

      this.userHostingSubscriptions = availableSubscriptions.filter(
        (subscription: any) =>
          subscription &&
          subscription.plan &&
          subscription.plan.shortFeatures &&
          subscription.plan.shortFeatures.active === "true"
      );

      for (const tab in tabs) {
        for (const category of categories) {
          const plan = await this._getTabs(category, tab);
          if (plan) {
            tabs[tab].push(plan);
          }
        }
      }

      this.subscriptionsTabs = tabs;

      // Check if the previously selected plan exists in the updated plans
      if (this.selectedPlanId) {
        const selectedPlan = this.subscriptionsTabs[this.activeTab]?.find(
          (subscription) => subscription.id === this.selectedPlanId
        );

        if (selectedPlan) {
          this.handlePlanChange({
            id: selectedPlan.id,
            title: selectedPlan.plan.title,
            price: selectedPlan.plan.planPrice,
            tabCategory: selectedPlan?.plan?.shortFeatures?.tabCategory,
            type: this.periodSwitch === 12 ? "year" : "month",
            planPrice: selectedPlan.plan.price,
            coupon: selectedPlan.couponCode,
            periodNumber: selectedPlan.plan.periodNumber,
          });
          return;
        }
      }

      // If the selected plan doesn't exist, keep the same plan type with the new periodSwitch
      if (this.chosenPlan) {
        const matchingPlan = this.subscriptionsTabs[this.activeTab]?.find(
          (subscription) =>
            subscription.plan.title === this.chosenPlan.title &&
            subscription.plan.periodNumber === this.periodSwitch
        );

        if (matchingPlan) {
          this.handlePlanChange({
            id: matchingPlan.id,
            title: matchingPlan.plan.title,
            price: matchingPlan.plan.planPrice,
            tabCategory: matchingPlan?.plan?.shortFeatures?.tabCategory,
            type: this.periodSwitch === 12 ? "year" : "month",
            planPrice: matchingPlan.plan.price,
            coupon: matchingPlan.couponCode,
            periodNumber: matchingPlan.plan.periodNumber,
          });
          return;
        }
      }

      // If nothing works, fallback to most popular plan
      const mostPopularPlan = this.subscriptionsTabs[this.activeTab]?.find(
        (subscription) =>
          this.planFeatures[this.activeTab][
            subscription?.category?.toLowerCase()
            ]?.mostPopular
      );

      if (mostPopularPlan) {
        this.handlePlanChange({
          id: mostPopularPlan.id,
          title: mostPopularPlan.plan.title,
          price: mostPopularPlan.plan.planPrice,
          tabCategory: mostPopularPlan?.plan?.shortFeatures?.tabCategory,
          type: this.periodSwitch === 12 ? "year" : "month",
          planPrice: mostPopularPlan.plan.price,
          coupon: mostPopularPlan.couponCode,
          periodNumber: mostPopularPlan.plan.periodNumber,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  private async _getTabs(category, tab): Promise<any> {
    const subscription = this.userHostingSubscriptions.find(
      (userSubscription: any) => {
        return this.isTier1Country || this.englishCountries
          ? this._getSubscription(userSubscription, category, tab, "b")
          : this._getSubscription(userSubscription, category, tab, "a");
      }
    );
    if (!!subscription &&
      this.hasCouponForCampaign &&
      subscription?.category !== UserSubscriptionCategory.DedicatedVM && !(subscription?.isEcommerce && subscription?.category === UserSubscriptionCategory.ENTERPRISE)
    ) {
      const coupon = localStorage.getItem("dbCouponFromEmail");
      this._applyCoupon(subscription?.id, coupon);
    }
    return subscription;
  }

  private _getSubscription(subscription, category, tab, variant): boolean {
    return (
      subscription &&
      subscription.plan &&
      subscription.variant === variant &&
      subscription.category === category &&
      subscription.tabCategory === tab &&
      subscription.plan.periodNumber === this.periodSwitch &&
      !!this.planFeatures?.[tab]?.[category]
    );
  }

  private _sendEvent(
    category = null,
    action = null,
    label = null,
    chosenPlan?
  ): void {
    const analyticsData = {
      eventCategory: category || "Dashboard Pageview",
      eventAction: action || "Checkout Page visit (1wf pop-up)",
      eventLabel: label || chosenPlan.title + " " + chosenPlan.type + "ly",
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _applyCoupon(subscriptionId, coupon): void {
    this._authService
      .applyCoupon(subscriptionId, coupon)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      )
      .subscribe((response) => {
        if (response.success) {
          this.applyCouponForPlatform = true;
          this.couponPercent = response.data.first_amount;
          this.couponDays = response.data.free_days_before_payment;
          const date = new Date();
          date.setDate(date.getDate() + this.couponDays);
          this.expirationDate = date.toDateString();
          this.hasFreeDays =
            response.data.free_days_before_payment &&
            response.data.free_days_before_payment !== 0;
        }
      });
  }

  private _getUserType(): void {
    this._store
      .select(fromStore.getUserLoaded)
      .pipe(
        first((loaded) => loaded),
        switchMap(() =>
          combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getWebsites),
            this._store.select(fromStore.getUserLocalStorage)
          )
        ),
        filter(([user, userSubscription]) => !!user && !!userSubscription),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([user, userSubscription, websites, userLocalStorage]) => {
        this.isEcommerceWebsite = websites.some(
          (website: Website) => !!website.isEcommerceWebsite
        );

        this.userSubscription = userSubscription;
        this.user = user;
        this.userLocalStorage = userLocalStorage;
        this.englishCountries = userLocalStorage && !!userLocalStorage.tier1B;
        this.demoUser = Utils.isDemoUser(userSubscription, user);
      });
  }

  private _generateDomainInfo(domainName): void {
    const domainInfo = JSON.stringify({
      want_domain: 1,
      domain_name: domainName || "",
    });
    localStorage.setItem("dbOnboardingDomainInfo", domainInfo);
    this.userLocalStorage["suggestedDomainName"] = domainName;
    this._updateLocalStorage();
  }

  private _updateLocalStorage(): void {
    this._userService
      .setToLocal(this.userLocalStorage)
      .pipe(first((response) => !!response, null))
      .subscribe((response) => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
          this._store.dispatch(new fromStore.LoadUser());
        }
      });
  }

  private _showSuccessfullyUpgradedDialog(): void {
    this._dialogService.addDialog(AccountUpgradedDialogComponent, {
      currentSubscription: this.userSubscription,
      upgradedFromTrial: true,
      upgradedFromBooster: false,
      isDemoUser: !!Utils.isDemoUser(this.userSubscription, this.user),
    });
  }

  private _handleSinglePlanMode(): void {
    if (this.singlePlanMode && this.subscriptionsTabs[this.activeTab]?.length) {
      const personalPlan = this.subscriptionsTabs[this.activeTab][0];
      const chosenPlan: ChosenPlan = {
        id: personalPlan.id,
        title: personalPlan.plan.title,
        tabCategory: personalPlan.plan?.shortFeatures?.tabCategory,
        price: personalPlan.plan.planPrice,
        type: this.periodSwitch === 12 ? "year" : "month",
        planPrice: personalPlan.plan.price,
        coupon: personalPlan.couponCode,
        periodNumber: personalPlan.plan.periodNumber,
      };
      this.chosenPlan = chosenPlan;
      const date = new Date();
      if (
        !this.mode &&
        this.chosenPlan.category !== UserSubscriptionCategory.DedicatedVM
      ) {
        date.setDate(date.getDate() + 7);
        this.expirationDate = date.toDateString();
      } else {
        this._setNextBillingDate(
          date,
          this.chosenPlan.type === "month" ? 30 : 365
        );
      }

      if (this.currentView === 'business' || this.currentView === 'ecommerce') {
        const analyticsData = {
          eventCategory: "Free Upgrade Offer",
          eventAction:
            "Checkout Page visit " +
            (!!this.mode ? "(Purchase pop-up)" : " Single plan"),
          eventLabel: this.chosenPlan.title + " " + this.chosenPlan.type + "ly",
        };
        this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
      }
    }
  }
}
